import {
  Layers,
  FlaskConical,
  ShieldHalf,
  Crown,
  Gauge,
} from "lucide-react";

const ITEMS = [
  {
    icon: Layers,
    title: "Enfoque Multidisciplinario Integrado",
    description:
      "Resolvemos cada caso desde la doble perspectiva legal y contable, eliminando brechas de información que suelen presentarse en despachos convencionales.",
  },
  {
    icon: FlaskConical,
    title: "Metodología Científica en Consultoría",
    description:
      "No nos basamos en suposiciones; nuestras auditorías y opinions técnicas están sustentadas en análisis de datos y procesos científicos que brindan certeza absoluta.",
  },
  {
    icon: ShieldHalf,
    title: "Blindaje Jurídico-Financiero",
    description:
      "Diseñamos estructuras que protegen el patrimonio de manera preventiva, anticipándonos a posibles contingencias antes de que se conviertan en conflictos legales.",
  },
  {
    icon: Crown,
    title: "Atención de Alta Nobleza",
    description:
      "Ofrecemos un trato personalizado y exclusivo, donde cada cliente tiene acceso directo a los socios expertos para el seguimiento de sus asuntos más críticos.",
  },
  {
    icon: Gauge,
    title: "Efectividad en Resolución de Trámites",
    description:
      "Poseemos un dominio profundo de los procesos administrativos, lo que nos permite agilizar gestiones que para otros podrían resultar burocráticamente imposibles.",
  },
];

export default function Distintivos() {
  return (
    <section
      id="distintivos"
      data-testid="distintivos-section"
      className="relative py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="grid lg:grid-cols-12 gap-10 mb-16 items-end">
          <div className="lg:col-span-7">
            <div className="reveal eyebrow mb-5">Nuestros Distintivos</div>
            <h2 className="reveal font-serif-display text-4xl sm:text-5xl lg:text-6xl leading-[1.05] tracking-tight text-neutral-950">
              Nobleza Corporativa{" "}
              <span className="italic text-[#E97906]">Sagitta</span>.
            </h2>
          </div>
          <div className="lg:col-span-5 reveal">
            <p className="text-neutral-600 text-base lg:text-[17px] leading-relaxed">
              Lo que nos diferencia de un despacho convencional: una arquitectura
              de cinco pilares que respalda cada decisión técnica y cada
              representación legal que asumimos.
            </p>
          </div>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 border border-neutral-200">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <div
                key={it.title}
                data-testid={`distintivo-${i}`}
                className={`reveal group relative p-8 lg:p-10 bg-white hover:bg-[#0A0A0A] hover:text-white transition-colors duration-500
                  ${i % 3 !== 2 ? "lg:border-r" : ""} ${i % 2 === 0 ? "md:border-r lg:border-r" : ""}
                  border-neutral-200 border-b last:border-b-0
                  ${i >= ITEMS.length - 1 ? "" : ""}`}
              >
                <div className="flex items-center justify-between mb-8">
                  <span className="font-serif-display text-sm tracking-widest text-neutral-400 group-hover:text-[#EDB900] transition-colors">
                    0{i + 1}
                  </span>
                  <span className="inline-flex items-center justify-center w-11 h-11 border border-neutral-200 group-hover:border-[#E97906] group-hover:text-[#E97906] transition-colors">
                    <Icon size={20} />
                  </span>
                </div>
                <h3 className="font-serif-display text-2xl leading-snug text-neutral-950 group-hover:text-white transition-colors">
                  {it.title}
                </h3>
                <p className="mt-4 text-sm leading-relaxed text-neutral-600 group-hover:text-neutral-300 transition-colors">
                  {it.description}
                </p>
                <span className="absolute left-0 bottom-0 h-[2px] w-0 bg-[#E97906] group-hover:w-full transition-all duration-700" />
              </div>
            );
          })}
          {/* Filler cell to keep grid clean on lg (5 items + 1 empty) */}
          <div className="hidden lg:flex items-end justify-end p-10 bg-[#FAFAFA] border-t border-neutral-200">
            <div className="text-right">
              <div className="eyebrow text-neutral-400">Sagitta</div>
              <div className="font-serif-display italic text-2xl text-neutral-700 mt-2 leading-snug">
                Donde la nobleza<br />encuentra la precisión.
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
